/**
 * Rounds up a cost to the nearest cent (2 decimal places)
 * For example:
 * - 0.035 -> 0.04
 * - 0.0553 -> 0.06
 * - 0.121 -> 0.13
 */
export function roundUpCost(cost: number): number {
  return Math.ceil(cost * 100) / 100;
}